var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8213 5.81778L14.4828 10.7778C14.2519 11.1156 14.6959 11.5244 15.0155 11.24L18.3008 8.37778C18.3896 8.30667 18.5139 8.36 18.5139 8.48444V17.4267C18.5139 17.5511 18.3541 17.6044 18.283 17.5156L8.33851 5.60444C8.01887 5.21333 7.55716 5 7.04218 5H6.68701C5.7636 5 5 5.76444 5 6.70667V19.2933C5 20.2356 5.7636 21 6.70477 21C7.29079 21 7.84129 20.6978 8.16093 20.1822L11.4994 15.2222C11.7303 14.8844 11.2863 14.4756 10.9667 14.76L7.68146 17.6044C7.59267 17.6756 7.46837 17.6222 7.46837 17.4978V8.57333C7.46837 8.44889 7.62819 8.39556 7.69922 8.48444L17.6437 20.3956C17.9634 20.7867 18.4428 21 18.9401 21H19.2952C20.2364 21 21 20.2356 21 19.2933V6.70667C20.9822 5.76444 20.2186 5 19.2775 5C18.6915 5 18.141 5.30222 17.8213 5.81778Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearIcon);
export default __webpack_public_path__ + "static/media/NearIcon.b6407695.svg";
export { ForwardRef as ReactComponent };